<template>
  <div
    id="mission"
    class="m-0 min-h-0 flex flex-col overflow-y-auto overflow-x-hidden max-h-[100dvh] sm:max-h-[100vh]"
  >
    <div
      class="card block relative w-full max-w-lg mt-6 sm:mt-8 md:mt-12 mx-auto p-4 sm:p-6 md:p-8 text-center box-border rounded-lg shrink-0"
    >
      <h2 class="mt-8 sm:mt-12 md:mt-20 mx-0 mb-4 text-xl sm:text-2xl">
        {{ $t('MissionCompleteComponent.missionCompleted') }}
      </h2>
      <i class="my-0 mx-2 block">
        <font-awesome-icon
          class="text-[var(--color-orange)] my-6 sm:my-8 md:my-12 mx-0 text-6xl sm:text-7xl md:text-8xl lg:text-9xl"
          icon="fa-circle-check"
        />
      </i>
      <p class="text-base sm:text-lg">{{ $t('MissionCompleteComponent.submittedAnswer') }}</p>
      <!-- External users: show thank-you message, no navigation into the platform -->
      <p
        v-if="isExternalUser"
        class="text-base sm:text-lg mt-6 sm:mt-8 text-[var(--color-grey-dark)]"
      >
        {{ $t('MissionCompleteComponent.thankYouExternal',
          'Thank you for your feedback! You can close this page now.') }}
      </p>
      <!-- Regular users: show "See results" button -->
      <Button
        v-else
        @click.prevent="navigateToResults"
        type="button"
        name="submit"
        id="btn_submit"
        class="btn-primary-accent inline-block w-full max-w-[12rem] h-12 mx-auto my-8 sm:my-12 md:my-20 text-base"
        unstyled
      >
        {{ $t('MissionCompleteComponent.seeResults') }}
      </Button>
    </div>
  </div>
</template>
<script>
import { Button } from 'primevue';

export default {
  name: 'MissionCompleteComponent',
  components: { Button },
  computed: {
    getRedirect() {
      return this.$store.state.questionnaireManagement.assessment?.properties?.linkAfterAssessment;
    },
    isExternalUser() {
      // External users arrive via externalToken in the URL query
      return !!this.$route.query.externalToken;
    },
  },
  methods: {
    navigateToResults() {
      const redirect = this.getRedirect;
      if (redirect && redirect !== '/') {
        this.$router.push(redirect);
        return;
      }
      const assessment = this.$store.state.questionnaireManagement?.assessment;
      const tabValue = assessment?.type || assessment?._id;
      if (tabValue) {
        this.$router.push({ name: 'myResultsDashboard', query: { tab: tabValue } });
      } else {
        this.$router.push({ name: 'myResultsDashboard' });
      }
    },
  },
  unmounted() {
    this.$store.commit('setIsDone', true);
  },
};
</script>
